import { render, staticRenderFns } from "./AstaAuctioneerRandom.vue?vue&type=template&id=0bdc24b6&scoped=true&"
import script from "./AstaAuctioneerRandom.vue?vue&type=script&lang=js&"
export * from "./AstaAuctioneerRandom.vue?vue&type=script&lang=js&"
import style0 from "./AstaAuctioneerRandom.vue?vue&type=style&index=0&id=0bdc24b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdc24b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bdc24b6')) {
      api.createRecord('0bdc24b6', component.options)
    } else {
      api.reload('0bdc24b6', component.options)
    }
    module.hot.accept("./AstaAuctioneerRandom.vue?vue&type=template&id=0bdc24b6&scoped=true&", function () {
      api.rerender('0bdc24b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/AstaAuctioneerRandom.vue"
export default component.exports